import React from "react";

const PositionPriceTrailDocs = (
    <>
        <p>
            This tactic sets a trail on the position symbol. As the trade moves in the
            direction of the Trade Plan (long/short), the trail adjusts in that
            direction.
        </p>
        <p>
            Ex: Let's say AAPL is at 449.75, and you want to buy on a break of 450, in
            options. Once the option loses 20 cents from its high, you would want to
            sell it. This tactic could accomplish that goal. You would set a trail of
            let's say 25 cents on AAPL. As the option continues to go higher, the trail
            adjusts higher with it. If you bought the option for 1$, the trail would
            start at .75. If the option moves to 1.5, the trail will adjust to 1.25.
            Once the option falls to 1.25, the position would flatten.
        </p>
    </>
);

export default PositionPriceTrailDocs;
